import type React from "react"
import { Editor } from "@tinymce/tinymce-react"

interface TinyMceEditorProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

const TinyMceEditor: React.FC<TinyMceEditorProps> = ({ value, onChange, placeholder }) => {
  return (
    <div className="tinymce-editor-wrapper">
      <Editor
        tinymceScriptSrc="https://cdn.jsdelivr.net/npm/tinymce@6/tinymce.min.js"
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 600,
          menubar: false,
          placeholder: placeholder || "Nhập nội dung...",
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "table link image | removeformat | code fullscreen",
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          branding: false,
          promotion: false,
        }}
      />
    </div>
  )
}

export default TinyMceEditor
